// Module
var code = `<template>
  <require from="./aggregated-fields-dialog.scss"></require>

  <mdc-dialog class="aggregated-fields-dialog" mdcdialog:closing.trigger="closing(\$event.detail.action)">
    <mdc-dialog-title>Select visible sums in Overview</mdc-dialog-title>
    <mdc-dialog-content>
      <mdc-data-table manual-checkbox-handling>
        <table>
          <thead>
            <th>Active</th>
            <th>Name</th>
          </thead>
          <tbody>
            <tr mdc-data-table-row repeat.for="f of data.fields">
              <td><mdc-checkbox checked.bind="f.show"></mdc-checkbox></td>
              <td>\${f.header}</td>
            </tr>
          </tbody>
        </table>
      </mdc-data-table>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <button mdc-button outlined click.trigger="setDefault()">Reset</button>
      <div class="mdc-dialog__action-spacer"></div>
      <button mdc-button outlined data-mdc-dialog-action="cancel">Cancel</button>
      <button mdc-button raised data-mdc-dialog-action="ok">Ok</button>
    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;